import type {
  APIBookingDraftBusServiceOption,
  APIBookingDraftCarRentalServiceOption,
  APIBookingDraftLuggageServiceOption,
  APIBookingDraftServiceCancellationInsuranceOption, APIBookingDraftSkiPassServiceOption, APIBookingDraftClothingServiceOption
} from '@/scopes/checkout/infrastructure/api/types';

export const enum ServiceTypeApi {
  ConditionalMessages = 'ConditionalMessagesComponent',
  BookingRedeemer = 'BookingRedeemer',
  ParticipantsBadge = 'ParticipantsBadge',
  SkiAncillaries = 'SkiAncillariesService',
  Luggage = 'LuggageService',
  CarRental = 'CarRentalService',
  CancellationInsurance = 'CancellationInsuranceComparisonTable',
  TShirt = 'TShirtService',
  Sweater = 'SweaterService',
  Generic = 'GenericService',
  Golf = 'GolfService',
  GenericPerUnitComponent = 'GenericPerUnitComponent',
  GenericPerParticipantSelection = 'GenericPerParticipantSelection',
}

export type ServiceRenderType = 'PerBooking' | 'PerParticipant' | undefined;

export interface APIBookingDraftService {
  aName: string;
  options: (
    | APIBookingDraftServiceOption
    | APIBookingDraftLuggageServiceOption
    | APIBookingDraftServiceCancellationInsuranceOption
    | APIBookingDraftBusServiceOption
    | APIBookingDraftCarRentalServiceOption
    | APIBookingDraftSkiPassServiceOption
    | APIBookingDraftClothingServiceOption
    )[];
  warnings?: APIBookingDraftServiceWarning[];
  isPricePerPerson?: boolean;
  renderType?: ServiceRenderType;
}

export interface APIBookingDraftServiceOption {
  displayText: string;
  bestValueText?: string;
  uniqueId?: string;
  code: string;
  price: number;
  percentage?: string;
  isSelected: boolean;
  isIncluded?: boolean;
  appliesToParticipants: number[];
  assignedParticipants: number[];
  prices?: APIBookingDraftServiceOptionParticipantPrice[];
}

export interface APIBookingDraftServiceOptionParticipantPrice {
  participantIds: number[];
  price: number;
}

export interface APIBookingDraftServiceWarning {
  title?: string;
  message?: string;
  type?: string;
}

export * from './carRental'
export * from './cancellationInsurance'
export * from './luggage'
export * from './ski'
export * from './bus'
export * from './clothing'
